import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aed20294")

_pushScopeId("data-v-aed20294")
const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "box-application__header text-center" }
const _hoisted_3 = { class: "box-application__title font-size-36 font-bold pb-4" }
const _hoisted_4 = { class: "box-application__information" }
const _hoisted_5 = { class: "box-application__box-date" }
const _hoisted_6 = { class: "box-application__label font-bold font-size-18" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "：", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "box-application__date" }, /*#__PURE__*/_toDisplayString('2021/00/0017:00'), -1)
const _hoisted_9 = { class: "box-application__type" }
const _hoisted_10 = { class: "box-application__label font-bold font-size-18" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "：", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "box-application__date" }, /*#__PURE__*/_toDisplayString('打刻申請'), -1)
const _hoisted_13 = { class: "box-application__target" }
const _hoisted_14 = { class: "box-application__label font-bold font-size-18" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "：", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "box-application__target-date" }, /*#__PURE__*/_toDisplayString('2021/04/01'), -1)
const _hoisted_17 = { class: "font-bold pb-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "box-application__content" }, null, -1)
const _hoisted_19 = { class: "box-application__content-wrapper" }
const _hoisted_20 = { class: "flex justify-center" }
const _hoisted_21 = { class: "font-bold" }
const _hoisted_22 = { class: "flex justify-center" }
const _hoisted_23 = { class: "flex justify-center" }
const _hoisted_24 = { class: "flex justify-center" }
const _hoisted_25 = { class: "flex justify-center" }
const _hoisted_26 = { class: "flex justify-center" }
const _hoisted_27 = { class: "box-application__footer" }
const _hoisted_28 = { class: "font-bold pt-3 pb-2" }
const _hoisted_29 = { class: "box-application__footer-wrapper" }
const _hoisted_30 = { class: "font-bold pt-6 pb-2" }
const _hoisted_31 = { class: "flex justify-center" }
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = { class: "flex justify-center" }
const _hoisted_34 = { class: "flex justify-center" }
const _hoisted_35 = { class: "flex justify-center" }
const _hoisted_36 = { class: "flex justify-center" }
const _hoisted_37 = { class: "flex justify-center" }
const _hoisted_38 = { class: "flex justify-center" }
const _hoisted_39 = { class: "flex justify-center items-center pt-8 pb-10" }
const _hoisted_40 = { class: "action-button-delete pr-3" }
const _hoisted_41 = { class: "action-button-delete pl-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Table = _resolveComponent("Table")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_GradationButton = _resolveComponent("GradationButton")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock(_component_Popup, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShow = $event)),
    width: "1086px",
    persistent: ""
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.t('applicationApprovalContent.title')), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.t('applicationDate')), 1),
            _hoisted_7,
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.t('applicationType2')), 1),
            _hoisted_11,
            _hoisted_12
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("span", _hoisted_14, _toDisplayString(_ctx.t('applicationTargetDate')), 1),
            _hoisted_15,
            _hoisted_16
          ]),
          _createVNode("h2", _hoisted_17, _toDisplayString(_ctx.t('applicationApprovalContent.title')), 1)
        ]),
        _hoisted_18,
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_Table, {
            headers: _ctx.applicationModalHeaders,
            data: _ctx.applicationModalData,
            "show-select": "",
            "selected-item": _ctx.applicationSelected,
            "onUpdate:selected-item": _cache[1] || (_cache[1] = ($event: any) => (_ctx.applicationSelected = $event))
          }, {
            title: _withId(({ item }) => [
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, _toDisplayString(item.title), 1)
              ])
            ]),
            attendance_work: _withId(({ item }) => [
              _createVNode("div", _hoisted_22, [
                _createVNode("div", null, _toDisplayString(item.attendance_work), 1)
              ])
            ]),
            leaving_work: _withId(({ item }) => [
              _createVNode("div", _hoisted_23, [
                _createVNode("span", null, _toDisplayString(item.leaving_work), 1),
                _createVNode("span", null, _toDisplayString(_ctx.t('applicationApprovalContent.exampleTime')), 1)
              ])
            ]),
            break_start: _withId(({ item }) => [
              _createVNode("div", _hoisted_24, [
                _createVNode("span", null, _toDisplayString(_ctx.t('applicationApprovalContent.exampleTime')), 1),
                _createVNode("div", null, _toDisplayString(item.break_start), 1)
              ])
            ]),
            break_end: _withId(({ item }) => [
              _createVNode("div", _hoisted_25, [
                _createVNode("span", null, _toDisplayString(_ctx.t('applicationApprovalContent.exampleTime')), 1),
                _createVNode("div", null, _toDisplayString(item.break_end), 1)
              ])
            ]),
            work_place: _withId(({ item }) => [
              _createVNode("div", _hoisted_26, [
                _createVNode("div", null, _toDisplayString(item.work_place), 1)
              ])
            ]),
            _: 1
          }, 8, ["headers", "data", "selected-item"]),
          _createVNode("div", _hoisted_27, [
            _createVNode("h2", _hoisted_28, _toDisplayString(_ctx.t('dailyAttendanceHeaders.applicationMessage')), 1),
            _createVNode(_component_InputArea, {
              placeholder: _ctx.t('applicationApprovalContent.textArea')
            }, null, 8, ["placeholder"])
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("h2", _hoisted_30, _toDisplayString(_ctx.t('applicationApprovalContent.applicationStatus')), 1),
          _createVNode(_component_Table, {
            headers: _ctx.applicationModalFooterHeaders,
            data: _ctx.applicationModalFooterData,
            "show-select": "",
            "selected-item": _ctx.applicationSelected,
            "onUpdate:selected-item": _cache[2] || (_cache[2] = ($event: any) => (_ctx.applicationSelected = $event))
          }, {
            titleFooter: _withId(({ item }) => [
              _createVNode("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, _toDisplayString(item.titleFooter), 1)
              ])
            ]),
            organizationFooter: _withId(({ item }) => [
              _createVNode("div", _hoisted_33, [
                _createVNode("div", null, _toDisplayString(item.organizationFooter), 1)
              ])
            ]),
            director: _withId(({ item }) => [
              _createVNode("div", _hoisted_34, [
                _createVNode("div", null, _toDisplayString(item.director), 1)
              ])
            ]),
            full_name: _withId(({ item }) => [
              _createVNode("div", _hoisted_35, [
                _createVNode("div", null, _toDisplayString(item.full_name), 1)
              ])
            ]),
            approver_comment: _withId(({ item }) => [
              _createVNode("div", _hoisted_36, [
                _createVNode("div", null, _toDisplayString(item.approver_comment), 1)
              ])
            ]),
            update_date_and_time: _withId(({ item }) => [
              _createVNode("div", _hoisted_37, [
                _createVNode("div", null, _toDisplayString(item.update_date_and_time), 1)
              ])
            ]),
            status: _withId(({ item }) => [
              _createVNode("div", _hoisted_38, [
                _createVNode("div", null, _toDisplayString(item.status), 1)
              ])
            ]),
            _: 1
          }, 8, ["headers", "data", "selected-item"])
        ]),
        _createVNode("div", _hoisted_39, [
          _createVNode("div", _hoisted_40, [
            _createVNode(_component_GradationButton, {
              onClick: _ctx.handleClose,
              class: "btn-add w-50"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('applicationApprovalContent.btnClose')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode("div", _hoisted_41, [
            _createVNode(_component_GradationButton, {
              class: "btn-with-draw w-50",
              onClick: _ctx.handleClose
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('applicationApprovalContent.withdrawApplication')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})